import { render, staticRenderFns } from "./RegularFilters.vue?vue&type=template&id=74a680cc&scoped=true"
import script from "./RegularFilters.vue?vue&type=script&lang=js"
export * from "./RegularFilters.vue?vue&type=script&lang=js"
import style0 from "./RegularFilters.vue?vue&type=style&index=0&id=74a680cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a680cc",
  null
  
)

export default component.exports